var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMyAi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#my_ai_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.041 11.305V7.734c0-1.184.96-2.143 2.143-2.143H12.9c1.183 0 2.142.96 2.142 2.143v3.571c0 1.184-.96 2.143-2.143 2.143H7.184a2.143 2.143 0 0 1-2.143-2.143ZM10.041 4.162v1.43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.267 1.14C6.127.93 8.17.764 10.042.764c1.873 0 3.916.166 5.778.377a2.755 2.755 0 0 1 2.427 2.442c.202 1.851.366 3.89.366 5.752 0 1.863-.164 3.906-.366 5.76a2.752 2.752 0 0 1-2.427 2.44c-1.862.21-3.905.372-5.778.372-1.633 0-3.395-.123-5.053-.294L.756 18.621l.981-4.512c-.153-1.576-.266-3.236-.266-4.774 0-1.861.166-3.9.368-5.752A2.756 2.756 0 0 1 4.267 1.14ZM8.127 9.186v.667M11.956 9.186v.667"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "my_ai_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgMyAi;